import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { AudienceGroupItem } from '@/components';
import { Card, Button } from 'antd';
import './index.less'

const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizModal } = component_tool;
class AudioControl extends WizContainer {
  componentName = "AudioControl";

  constructor(props) {
    super(props);
    let { bizType, bizId, validBiz } = props
    log.info('props', props);
    this.state = {
      previewAudioVisible: false,
      previewAudio: {},
      previewAudioKey: new Date().getTime(),
      scope: {},
      bizType,
      bizId,
      validBiz
    };
  }
  handleCancel = () => {
    this.setState({ previewAudioVisible: false })
  }
  openAudio = ({ fileId, thirdUrl, fileName, id }) => {
    let audioProps = {
      fileId,
      thirdUrl,
      title: fileName,
      id: id,
      type: 'audio/mpeg',
    }
    this.setState({ previewAudioVisible: true, previewAudio: audioProps, previewAudioKey: new Date().getTime() })
  }
  _render() {
    const { audioList } = this.props
    const { visible, scope, bizType, bizId, validBiz } = this.state
    return (
      <React.Fragment>
        {audioList.map(item => {
          return (
            <div className="audio-control">
              {item.fileId || item.thirdUrl ? <a className="audio-link" onClick={() => this.openAudio(item)}><img className="audio-icon" src={constants.files.sys_sound_play_icon}></img> {item.fileName}</a>
                : null}
            </div>
          )
        })}
        <WizModal key={'audio_preview_' + this.state.previewAudioKey} visible={this.state.previewAudioVisible}
          footer={null}
          onCancel={this.handleCancel}>
          {
            this.state.previewAudioVisible ? <Audio {...this.state.previewAudio} /> : null
          }
        </WizModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps)(AudioControl);
// 音频
function Audio({ fileId, thirdUrl, id, title, type }) {
  const openDownLoad = (thirdUrl) => {
    window.open(thirdUrl)
  }
  return (
    <Card key={'player_' + id} className={'wizCard-title-span'} bordered={false}>
      <audio controls controlslist='nodownload'>
        <source src={fileId ? getOssFilePath(fileId) : thirdUrl} type={type} controlslist='nodownload' />
      </audio><br />
      <div className={'text-online'}><span>{title}</span><Button onClick={() => openDownLoad(fileId ? getOssFilePath(fileId) : thirdUrl)}>下载</Button>
      </div>
    </Card>
  )
}
